<div class="grid-detail-wrap border bg-white mb-4">
  <div class="row justify-content-between mb-2">
    <div class="col-md-11">
      <h2>{{ 'SERVICE_MASTER_CATEGORY' | translate }}</h2>
      <dx-select-box
        [items]="this.masterCategories"
        [(value)]="this.category.masterCategoryId"
        [displayExpr]="this.isLanguageUa ? 'nameUa' : 'nameRu'"
        valueExpr="id"
        class="w-100 mb-3"></dx-select-box>

      <h2>{{ 'SERVICES_CATEGORIES_NAME_WEB' | translate }} ({{ 'UA_LANG_SMALL_SHORT' | translate }})</h2>
      <dx-text-area [(value)]="this.category.webNameUa" class="w-100 mb-3"></dx-text-area>
      <h2>{{ 'SERVICES_CATEGORIES_NAME_WEB' | translate }} ({{ 'RU_LANG_SMALL_SHORT' | translate }})</h2>
      <dx-text-area [(value)]="this.category.webNameRu" class="w-100"></dx-text-area>
    </div>

    <div class="col-md-12">
      <div class="category-description">
        <h2>{{ 'DESCRIPTION' | translate }} ({{ 'UA_LANG_SMALL_SHORT' | translate }})</h2>
        <dx-text-area [(value)]="this.category.descriptionUa" class="w-100 mb-3"></dx-text-area>
        <h2>{{ 'DESCRIPTION' | translate }} ({{ 'RU_LANG_SMALL_SHORT' | translate }})</h2>
        <dx-text-area [(value)]="this.category.descriptionRu" class="w-100"></dx-text-area>
      </div>
    </div>
  </div>
</div>

<dx-button text="{{ 'SAVE' | translate }}" icon="mdi mdi-content-save" class="btn" (onClick)="this.save()"></dx-button>
